/** 鉴别作业列表：日期段展示为 [当天, 次日]，接口按当天 00:00～23:59:59 查询 */

export function formatDay(d) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function formatDateTime(d) {
  if (!d) return "";
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export function addCalendarDays(dateStr, days) {
  const parts = dateStr.split("-").map(Number);
  const cal = new Date(parts[0], parts[1] - 1, parts[2]);
  cal.setDate(cal.getDate() + days);
  return formatDay(cal);
}

/** 默认：今天 00:00 ～ 明天 00:00（选择器显示为 [今天, 明天]） */
export function buildDefaultTimeRange() {
  const today = formatDay(new Date());
  return [today, addCalendarDays(today, 1)];
}

/**
 * 待发货列表默认时间：上一次发货时刻 ～ 当前时刻（精确到秒，不再按自然日）。
 * lastDeliveryTime 为空时返回 null（不过滤）。
 */
export function buildSinceLastDeliveryTimeRange(lastDeliveryTime) {
  if (!lastDeliveryTime) {
    return null;
  }
  const start = formatDateTime(lastDeliveryTime);
  if (!start) {
    return null;
  }
  return [start, formatDateTime(new Date())];
}

/**
 * 将时间范围转为接口参数。
 * 结束日为「开始日+1天」时视为右开区间到次日 0 点，仅查开始日当天（兼容旧日期选择器）。
 * 含时分秒的范围原样传递。
 */
export function resolveCreateTimeRange(timeRange) {
  if (!timeRange || timeRange.length !== 2) {
    return {};
  }
  const startTime = timeRange[0];
  const endTime = timeRange[1];
  if (!startTime || !endTime) {
    return {};
  }
  const startIsDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(startTime);
  const endIsDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(endTime);
  if (startIsDateOnly && endIsDateOnly && endTime === addCalendarDays(startTime, 1)) {
    return { startTime, endTime: startTime };
  }
  return { startTime, endTime };
}



// WEBPACK FOOTER //
// ./src/util/inspectionJobTimeRange.js